import { Component, Input, Output, EventEmitter, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'mainpanel',
    templateUrl: './main-panel.component.html',
    styleUrls: ['./main-panel.component.scss'],
    standalone: false
})
export class MainPanelComponent {
  hover: boolean;
  @Input() Title: string | null
  @Input() text: number;
  @Output() textChange = new EventEmitter();

  @Input() showBarcodeScanner: boolean = false;
  barcodeQuery: string;
  @Output() barcodeQueryChange = new EventEmitter<string>();

  @Input() offline: any;

  @Input() filterWidth: string = 'auto';
  @Input() pageData: any;
  @Input() hideSearchBox: any;
  @Input() hideSearchDropdown: any;
  @Input() searchBoxPlaceholder: string;
  @Input() hideMoreMenu = false;

  /**
   * Auto complete
   */
  @Input() filterAutoComplete = false;
  @Input() requestUrl: string;
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEnter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  isChange: boolean;

  constructor(private router: Router) {
      this.searchBoxPlaceholder = this.searchBoxPlaceholder || 'Search..'
  }

  submit(): void {
      this.onSubmit.emit();
  }
  onTextChange(): void {
      this.textChange.emit(this.text);
  }
  onBarcodeQueryChange() {
      this.barcodeQueryChange.emit(this.barcodeQuery);
      this.barcodeQuery = '';
  }
  toggleDropdown(event: any) {
      event.stopPropagation();
  }

  onAutoCompleteChange(event: any) {
      this.onSelect.emit(event);
  }
  onAutoCompleteEnter(event: any) {
      this.onEnter.emit(event)
  }
}

@NgModule({
  declarations: [MainPanelComponent],
  imports: [CommonModule, FormsModule, RouterModule],
  exports: [MainPanelComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class MainPanelModule { }